/**=========================================================
 * Module: workspaces.js
 * Workspaces Controller
 =========================================================*/

 App.controller("WorkspacesController", ["$rootScope", "$scope", "$state", "$translate", "$window", "$localStorage", "$timeout", "toggleStateService", "Restangular", "DataService", '$http',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $http) 
 {
   "use strict";

   $scope.page = {
     title: "AWS Workspaces",
     subTitle: ""
   };

   $scope.reserveWS = function(wsId){
     D.save('property', {
       action: 'ReserveWorkspace',
       wsId: wsId
     }).then(function(){
       load();
     }).catch(console.error)
   }
   $scope.unreserveWS = function(wsId){
    D.save('property', {
      action: 'ReserveWorkspace',
      wsId: wsId,
      releaseWS: true
    }).then(function(){
      load();
    }).catch(console.error)
  }
  $scope.rebootWS = function(wsId){
    D.save('Function', 'workspaces', {
      id: wsId,
      action: 'reboot'
    }).then(function(data){

    });
  }

  $scope.userInWorkspace = null

  $scope.loading = false;
  
   function load(){
     $scope.loading = true;
    D.query('property','set=workspace', { cache: false }).then(function(response){
      var pWS = {};
      for(var i=0; i<response.length; i++){
        var w = JSON.parse(response[i].value);
        pWS[w.wsId] = w;
      }
      D.load('Function', 'workspaces').then(function(data){
        moment.locale($rootScope.user.language.substr(0,2));
        var ws = data.Workspaces;
        var wscs = data.WorkspacesConnectionStatus;
        $scope.userInWorkspace = false;
        for(var i=0; i<ws.length; i++){
          for(var j=0; j<wscs.length; j++){
            if(wscs[j].WorkspaceId == ws[i].WorkspaceId){
              try{
                wscs[j].ConnectionStateCheckTimestampFN = moment(wscs[j].ConnectionStateCheckTimestamp).fromNow();
                wscs[j].LastKnownUserConnectionTimestampFN = moment(wscs[j].LastKnownUserConnectionTimestamp).fromNow();
                ws[i].ConnectionStatus = wscs[j];
                ws[i].AqrateUser = pWS[ws[i].WorkspaceId] && pWS[ws[i].WorkspaceId].user;
                if(ws[i].AqrateUser==$rootScope.user.id){ $scope.userInWorkspace = true; }
                ws[i].AqrateUserName = pWS[ws[i].WorkspaceId] && pWS[ws[i].WorkspaceId].userName;
                ws[i].AqrateUserPicture = pWS[ws[i].WorkspaceId] && pWS[ws[i].WorkspaceId].userPicture;
                ws[i].AqrateUserTimestamp = pWS[ws[i].WorkspaceId] && pWS[ws[i].WorkspaceId].timestamp;
                if(ws[i].AqrateUserTimestamp > new Date().getTime() - 360000){
                  ws[i].ConnectionStatus.ConnectionState = 'CONNECTED';
                  ws[i].ConnectionStatus.ConnectionStateCheckTimestamp = ws[i].AqrateUserTimestamp;
                  ws[i].ConnectionStatus.ConnectionStateCheckTimestampFN = moment(ws[i].AqrateUserTimestamp).fromNow();
                }
              } catch(err){
                
              }
            }
          }
        }
        ws.sort(function(a,b){
          return a.UserName > b.UserName ? 1 : -1;
        })
        $scope.workspaces = ws;
        updateTimestamps();
        $scope.loading = false;
        $timeout(load, 600000);
      })
    }).catch(console.error);
   }
   load();

   function updateTimestamps(){
     for(var i=0; i<$scope.workspaces.length; i++){
       $scope.workspaces[i].ConnectionStatus.ConnectionStateCheckTimestampFN = moment($scope.workspaces[i].ConnectionStatus.ConnectionStateCheckTimestamp).fromNow();
     }
     $timeout(updateTimestamps, 60000);
   }
   

   $scope.reload = load;

   $scope.$on('$destroy', function iVeBeenDismissed() {
     $scope.load = function() { };
   });
 }
]);
